import React, {useState} from "react";
import {SearchToSelect} from "../../../components";
import reactSelectStyles from "../../../services/config/reactSelect/reactSelectStyles";
import reactSelectTheme from "../../../services/config/reactSelect/reactSelectTheme";
import Select from "react-select";


function TemplateSelector({localPagesTemplateList, startingValue,  templateSelectedFunction}) {

    const [currentTemplateSelection, setCurrentTemplateSelection] = useState(startingValue)

    const searchTemplates = (query) => {
        const lowercase = query.toLowerCase();
        const choices = localPagesTemplateList.filter(template => template.templateName.toLowerCase().includes(lowercase)).sort();
        return choices
    };

    const templateSelected = (selection) => {
        setCurrentTemplateSelection(selection)
        templateSelectedFunction(selection)
    }

    return <div>
        <h5> Template </h5>
        <SearchToSelect
            placeholder={"Select Template"}
            options={localPagesTemplateList}
            renderOption={template => template.templateName}
            onSelected={templateSelected}
            getKey={template => template._id}
            getSearchResults={({query}) => searchTemplates(query)}
            selected={currentTemplateSelection}
        />
    </div>


}

export default TemplateSelector;